import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "leave-container" }
const _hoisted_2 = { class: "action-panel-card" }
const _hoisted_3 = { class: "panel-header" }
const _hoisted_4 = { class: "form-group-custom" }
const _hoisted_5 = {
  class: "form-group-custom",
  style: {"padding-top":"10px"}
}
const _hoisted_6 = {
  class: "form-group-custom",
  style: {"padding-top":"10px"}
}
const _hoisted_7 = {
  class: "form-item-toggle",
  style: {"margin-top":"15px","margin-bottom":"15px"}
}
const _hoisted_8 = { class: "form-group-custom" }
const _hoisted_9 = {
  key: 0,
  class: "reporting-boss-tip"
}
const _hoisted_10 = { class: "submit-btn-wrapper" }
const _hoisted_11 = { class: "history-section" }
const _hoisted_12 = { class: "section-header" }
const _hoisted_13 = {
  key: 0,
  class: "history-loading"
}
const _hoisted_14 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_15 = {
  key: 2,
  class: "requisition-list"
}
const _hoisted_16 = ["data-push-id"]
const _hoisted_17 = { class: "req-header" }
const _hoisted_18 = { class: "req-date" }
const _hoisted_19 = { class: "req-body" }
const _hoisted_20 = { class: "req-info-row" }
const _hoisted_21 = { class: "req-info-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "light" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Manual Attendance Request", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "leave-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ion_icon, {
                  icon: _ctx.timeOutline,
                  class: "panel-header-icon"
                }, null, 8, ["icon"]),
                _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Submit Forgotten Attendance", -1))
              ]),
              _createElementVNode("form", {
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitRequest && _ctx.submitRequest(...args)), ["prevent"])),
                class: "leave-form"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_ion_item, {
                    class: "form-item-custom",
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.listOutline,
                        slot: "start",
                        class: "field-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, {
                        position: "floating",
                        class: "custom-label"
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("Request Type ", -1),
                          _createElementVNode("span", { class: "required" }, "*", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select, {
                        modelValue: _ctx.form.type,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.type) = $event)),
                        required: "",
                        interface: "action-sheet",
                        class: "custom-select",
                        placeholder: "Select Type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "in" }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode("Check In", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "out" }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("Check Out", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_ion_item, {
                    class: "form-item-custom",
                    lines: "none",
                    style: {"display":"flex","justify-content":"space-between","align-items":"center"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.calendarOutline,
                        slot: "start",
                        class: "field-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "custom-label" }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("Requested Date ", -1),
                          _createElementVNode("span", { class: "required" }, "*", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_datetime, {
                        "display-format": "YYYY-MM-DD",
                        placeholder: "Select Date",
                        modelValue: _ctx.form.requested_date,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.requested_date) = $event)),
                        mode: "ios",
                        min: _ctx.dateMin,
                        max: _ctx.dateMax
                      }, null, 8, ["modelValue", "min", "max"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_ion_item, {
                    class: "form-item-custom",
                    lines: "none",
                    style: {"display":"flex","justify-content":"space-between","align-items":"center"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.timeOutline,
                        slot: "start",
                        class: "field-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "custom-label" }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("Exact Time ", -1),
                          _createElementVNode("span", { class: "required" }, "*", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_datetime, {
                        "display-format": "hh:mm A",
                        placeholder: "Select Time",
                        modelValue: _ctx.form.time,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.time) = $event)),
                        mode: "ios"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "toggle-info" }, [
                    _createElementVNode("span", { class: "toggle-title" }, "Field Visit / Off-site Work"),
                    _createElementVNode("span", { class: "toggle-subtitle" }, "Toggle if you left from outside the office")
                  ], -1)),
                  _createVNode(_component_ion_toggle, {
                    modelValue: _ctx.form.is_field_visit,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.is_field_visit) = $event)),
                    color: "primary"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ion_item, {
                    class: "form-item-custom",
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.documentTextOutline,
                        slot: "start",
                        class: "field-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, {
                        position: "floating",
                        class: "custom-label"
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode("Reason ", -1),
                          _createElementVNode("span", { class: "required" }, "*", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_textarea, {
                        modelValue: _ctx.form.reason,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.reason) = $event)),
                        required: "",
                        placeholder: "Why did you forget to checkout?",
                        class: "custom-input"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.config && _ctx.config.reporting_boss)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.personOutline,
                        class: "boss-icon"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, [
                        _cache[15] || (_cache[15] = _createTextVNode("Requires verification by: ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.config.reporting_boss), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ion_button, {
                    type: "submit",
                    expand: "block",
                    shape: "round",
                    color: "primary",
                    class: "custom-submit-btn",
                    disabled: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      (_ctx.loading)
                        ? (_openBlock(), _createBlock(_component_ion_spinner, {
                            key: 0,
                            name: "crescent",
                            slot: "start"
                          }))
                        : (_openBlock(), _createBlock(_component_ion_icon, {
                            key: 1,
                            icon: _ctx.checkmarkCircleOutline,
                            slot: "start"
                          }, null, 8, ["icon"])),
                      _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Submitting...' : 'Submit Request'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_ion_icon, {
                  icon: _ctx.listOutline,
                  class: "section-icon"
                }, null, 8, ["icon"]),
                _cache[16] || (_cache[16] = _createElementVNode("h3", null, "My Past Requests", -1))
              ]),
              (_ctx.loadingHistory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_ion_spinner, {
                      name: "crescent",
                      color: "primary"
                    })
                  ]))
                : (_ctx.requests.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_ion_icon, { icon: _ctx.folderOpenOutline }, null, 8, ["icon"]),
                      _cache[17] || (_cache[17] = _createElementVNode("p", null, "No past requests found.", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requests, (req) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: req.id,
                          class: _normalizeClass(["req-card", _ctx.pushFocusClass(req.id)]),
                          "data-push-id": req.id
                        }, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(req.requested_date) + " | " + _toDisplayString(req.type === 'in' ? 'Check In' : 'Check Out') + " at " + _toDisplayString(req.time), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(_ctx.getStatusBadgeClass(req.status))
                            }, _toDisplayString(req.status), 3)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_ion_icon, { icon: _ctx.locationOutline }, null, 8, ["icon"]),
                              _createElementVNode("span", null, _toDisplayString(req.is_field_visit ? 'Field Visit' : (req.office ? req.office.name : 'Office')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_ion_icon, { icon: _ctx.documentTextOutline }, null, 8, ["icon"]),
                              _createElementVNode("span", null, _toDisplayString(req.reason), 1)
                            ])
                          ])
                        ], 10, _hoisted_16))
                      }), 128))
                    ]))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}